import { dateFormats, swaDate } from "@swa-ui/date";
import { getUrlForSite } from "@swa-ui/dotcom";
import { createHrefWithSearchParams } from "@swa-ui/href";

import { LAP_CHILDREN, OLDER_CHILD, TEENS, YOUNGER_CHILD } from "../../../defines/passengerType";
import { MULTICITY, ONEWAY } from "../../../defines/tripType";
import { shouldUseLowFareCalendar } from "./shouldUseLowFareCalendar";
import { getAreaAirportValue, getFromOrToValue, getLfcStationValue } from "./stationValue";

export const getAirBookingSearchHref = (
  submittedFormData,
  site = "southwest",
  defaultFormDataOverride,
  enableInternalNavigation
) => {
  const {
    adultPassengersCount,
    chaseCardValue,
    departureDate,
    destinationAirportCode,
    int,
    lowFareCalendar,
    originationAirportCode,
    passengers,
    passengerTier,
    passengerType,
    promoCode,
    returnAirportCode,
    returnDate,
    searchParams = {},
    showFareInPoints,
    tripType,
    fareType,
  } = submittedFormData;
  const isMobileAreaAirport = (airportCode) =>
    site === "mobile" && Array.isArray(airportCode) && airportCode.length > 1;
  const airQueryParams = {
    adultsCount: passengers?.adults?.toString(),
    adultPassengersCount,
    ...(chaseCardValue && { chaseCardValue }),
    destinationAirportCode: isMobileAreaAirport(destinationAirportCode)
      ? getFromOrToValue(destinationAirportCode)
      : getAreaAirportValue(destinationAirportCode),
    departureDate: swaDate(departureDate).format(dateFormats.iso),
    departureTimeOfDay: "ALL_DAY",
    fareType: fareType || (showFareInPoints ? "POINTS" : "USD"),
    int,
    originationAirportCode: isMobileAreaAirport(originationAirportCode)
      ? getFromOrToValue(originationAirportCode)
      : getAreaAirportValue(originationAirportCode),
    ...(passengerTier && { passengerTier }),
    passengerType,
    promoCode,
    returnDate: tripType !== ONEWAY ? swaDate(returnDate).format(dateFormats.iso) : "",
    returnTimeOfDay: "ALL_DAY",
    tripType,
    ...(Array.isArray(originationAirportCode) &&
      originationAirportCode.length > 1 && { from: getFromOrToValue(originationAirportCode) }),
    ...(Array.isArray(destinationAirportCode) &&
      destinationAirportCode.length > 1 && { to: getFromOrToValue(destinationAirportCode) }),
    ...(returnAirportCode && tripType === MULTICITY && { returnAirportCode }),
    ...(passengers[LAP_CHILDREN] > 0 && {
      lapInfantPassengersCount: passengers[LAP_CHILDREN]?.toString(),
    }),
    ...(passengers[OLDER_CHILD] > 0 && {
      olderChildCount: passengers[OLDER_CHILD]?.toString(),
    }),
    ...(passengers[YOUNGER_CHILD] > 0 && {
      youngerChildCount: passengers[YOUNGER_CHILD]?.toString(),
    }),
    ...(passengers[TEENS] > 0 && { teensCount: passengers[TEENS]?.toString() }),
    ...searchParams,
  };
  const lfcQueryParams = {
    adultPassengersCount,
    adultsCount: passengers?.adults?.toString(),
    destinationAirportCode: getLfcStationValue(destinationAirportCode),
    currencyCode: fareType || (showFareInPoints ? "POINTS" : "USD"),
    departureDate: swaDate(departureDate).format(dateFormats.iso),
    fareType: fareType || (showFareInPoints ? "POINTS" : "USD"),
    int,
    lapInfantPassengersCount: passengers?.lapChildren?.toString(),
    ...(passengers[OLDER_CHILD] > 0 && {
      olderChildCount: passengers[OLDER_CHILD]?.toString(),
    }),
    originationAirportCode: getLfcStationValue(originationAirportCode),
    passengerType,
    promoCode,
    returnAirportCode: tripType === MULTICITY && returnAirportCode ? returnAirportCode : "",
    returnDate: tripType !== ONEWAY ? swaDate(returnDate).format(dateFormats.iso) : "",
    selectedFlight1: swaDate(departureDate).format(dateFormats.iso),
    selectedFlight2: tripType !== ONEWAY ? swaDate(returnDate).format(dateFormats.iso) : "",
    ...(passengers[TEENS] > 0 && { teensCount: passengers[TEENS]?.toString() }),
    tripType,
    ...(passengers[YOUNGER_CHILD] > 0 && {
      youngerChildCount: passengers[YOUNGER_CHILD]?.toString(),
    }),
    ...searchParams,
  };
  const useLowFareCalendar = shouldUseLowFareCalendar(
    defaultFormDataOverride?.useLowFareCalendar,
    lowFareCalendar
  );
  const urlKey = useLowFareCalendar
    ? enableInternalNavigation
      ? "AIR_LOW_FARE_CALENDAR_SELECT_DATES_V2"
      : "AIR_LOW_FARE_CALENDAR_SELECT_DATES"
    : "AIR_BOOKING_SELECT_DEPART";
  const queryParams = useLowFareCalendar ? lfcQueryParams : airQueryParams;

  return createHrefWithSearchParams(getUrlForSite(urlKey, site), queryParams)?.href;
};
